import { ChangeDetectorRef, Directive, ElementRef, Input } from '@angular/core';

import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { I18nService } from '@recruitee/i18n';

import { ClipboardCopy } from '../../clipboard-copy.service';

@Directive({
  selector: '[rtClickToCopy]',
  host: {
    class: 'click-to-copy',
    '(click)': 'copy()',
  },
  standalone: true,
})
export class ClickToCopyDirective {
  @Input() public rtClickToCopy: string | number;

  private ngOnDestroy$: Subject<void> = new Subject();

  constructor(
    private clipboardCopy: ClipboardCopy,
    private i18n: I18nService,
    private cdRef: ChangeDetectorRef,
    private elRef: ElementRef,
  ) {}

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public copy(): void {
    // eslint-disable-next-line no-restricted-properties
    const { innerHTML } = this.elRef.nativeElement;
    this.clipboardCopy.fromString(this.rtClickToCopy.toString(), null);
    this.render(`${this.i18n.translate('app.common.copied')}!`);
    this.cdRef.detectChanges();
    timer(3000)
      .pipe(takeUntil(this.ngOnDestroy$.asObservable()))
      .subscribe(() => {
        this.render(innerHTML);
        this.cdRef.detectChanges();
      });
  }

  private render(text: string | number): void {
    // eslint-disable-next-line no-restricted-properties
    this.elRef.nativeElement.innerHTML = text;
  }
}
